// extracted by mini-css-extract-plugin
export default {"menu_item":"_1Z_M","expand_icon":"_3mlf"};